<template>
    <b-card no-body>
        <div>
            <tarefa-aprovacao-almoxarifado-modal v-if="showTarefaAprovacaoAlmoxarifadoModal"
                :numeroDevolucao="this.selectedItem.devolucao.id" :tarefa="selectedItem" uri="/aprovacao-almoxarifado"
                propQuantidade="quantidadeAprovada"
                @tarefaAlmoxarifadoFinalizado="tarefaAprovacaoAlmoxarifadoFinalizado" @close="modalClose"
                :isVisualizacao="isVisualizacao"
                :devolucao="selectedItem.devolucao"></tarefa-aprovacao-almoxarifado-modal>

            <tarefa-aprovacao-solicitante-modal v-if="showTarefaAprovacaoSolicitanteModal"
                :numeroDevolucao="selectedItem.devolucao.id" :tarefa="selectedItem" uri="/aprovacao-retirada"
                @tarefaAprovacaoFinalizado="tarefaAprovacaoSolicitanteFinalizado" @close="modalClose"
                :isVisualizacao="isVisualizacao"
                :devolucao="selectedItem.devolucao"></tarefa-aprovacao-solicitante-modal>
        </div>

        <b-card-body>
            <b-card bg-variant="light">
                <b-form-row @keyup.enter="load">
                    <b-col lg="3" sm="12" class="text-left">
                        <lg-form-input invalidFeedback="O número produto deve ser informado!" description=""
                            v-model="form.tarefaId" label="Número:" />
                    </b-col>
                    <b-col lg="5" sm="12" class="text-left pl-0">
                        <LgFinderPageAlmoxarifado id="finderPageAlmoxarifado" @onselect="setAlmoxarifado"
                            v-model="form.almoxarifado" invalidFeedback="almoxarifado deve ser informado!"
                            label="Almoxarifado:" :prefix="prefix + title + ' > '" />
                    </b-col>
                </b-form-row>

                <b-form-row @keyup.enter="load">
                    <b-col lg="4" sm="12" class="text-left mr-3">
                        <lg-form-select @input="load" v-model="form.status" :loadFunction="listStatus"
                            labelFormGroupBind="Status:" label="descricao" description="" filterList="true"
                            class="nowrap" />
                    </b-col>

                    <b-col lg="4" sm="8" class="mr-4">
                        <lg-form-select @input="load" v-model="form.tipoTarefa" :loadFunction="listTipoTarefaDevolucao"
                            labelFormGroupBind="Tipo Tarefa" label="descricao" description="" filterList="true" />
                    </b-col>

                    <b-col cols="3" class="text-right ml-3 mt-1">
                        <b-button id="apagarTarefaDevoluacaoList" style="height: 20px;" class="ml-3 mr-2 my-2" size="sm"
                            pill @click="clearForm">
                            <div class="btn-size-alinhamento">

                                <b-icon icon="eraser" />
                            </div>
                            <b-tooltip title="Limpar" target="apagarTarefaDevoluacaoList"></b-tooltip>
                        </b-button>

                        <b-button class=" mr-2 my-2" size="sm" style="height: 20px;" pill variant="primary"
                            @click="load" id="localizarTarefaDevoluacaoList">
                            <div class="btn-size-alinhamento">

                                <b-icon icon="search" />
                            </div>
                            <b-tooltip title="Localizar" target="localizarTarefaDevoluacaoList"></b-tooltip>
                        </b-button>
                    </b-col>
                </b-form-row>
                <b-table responsive class="mt-2" small :busy="busy" :items="records" :fields="tableFields" hover
                    show-empty>
                    <template #empty>
                        <p>Nenhum registro encontrado</p>
                    </template>

                    <template #table-busy>
                        <div class="text-center text-primary my-2">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                    </template>

                    <template v-slot:cell(tipoTarefaDevolucao)="{ item }">
                        <span @click="abrirDetalhe(item)" style="color: blue; cursor: pointer">{{
                            item.tipoTarefaDevolucao.descricao
                        }}</span>
                    </template>

                    <template v-slot:cell(actionButtons)="{ item }">
                        <div class="text-center">
                            <b-button id="iniciar" v-if="verificaPrivilegioTarefa(item) && item.status.id === 127" pill
                                size="sm" variant="primary" title="Iniciar a tarefa atual..."
                                @click="iniciarTarefa(item)">
                                <b-icon icon="file-earmark-play" />
                            </b-button>
                            <b-button v-if="
                                verificaPrivilegioTarefa(item) &&
                                item.tipoTarefaDevolucao.id === 10 && item.status.id !== 127 && item.status.id !== 129
                            " pill size="sm" variant="primary" title="Continuar a tarefa atual..."
                                @click="abrirModalAlmoxarifadoModal(item)">
                                <b-icon icon="file-earmark-arrow-up" />
                            </b-button>

                            <b-button v-if="
                                verificaPrivilegioTarefa(item) &&
                                item.tipoTarefaDevolucao.id === 13 && item.status.id !== 127 && item.status.id !== 129
                            " pill size="sm" variant="primary" title="Continuar a tarefa atual..."
                                @click="abrirModalSolicitanteModal(item)">
                                <b-icon icon="file-earmark-arrow-up" />
                            </b-button>
                        </div>
                    </template>
                </b-table>

                <b-row style="margin-top: 12px" v-if="records && records.length > 0">
                    <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">
                        <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Página {{ page }} de
                            {{
                                totalPage }} -
                            {{ total }} registros</b-col>
                        <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Mostrando:&nbsp;
                            <b-form-select size="sm" v-model="perPage" @change="() => this.load()"
                                :options="perPageOptions">
                            </b-form-select>
                        </b-col>
                    </b-col>
                    <b-col cols="6">
                        <div class="d-flex justify-content-end align-items-end">
                            <b-pagination style="margin-bottom: 10px; margin-top: 10px" v-model="page"
                                :per-page="perPage" :total-rows="total"></b-pagination>
                        </div>
                    </b-col>
                </b-row>
            </b-card>
        </b-card-body>
    </b-card>
</template>

<script>
import Formatters from "@/core/mixins/formatters"
import ResourceService from "@/core/api/ResourceService"
import LgFormInput from "@/core/components/Form/LgFormInput.vue"
import LgFormSelect from "@/core/components/Form/LgFormSelect.vue"
import ConfirmMixin from "@/core/mixins/confirm"
import { FormResourceMixin, ListResourceMixin } from "@/core/mixins/resource"
import TarefaAprovacaoAlmoxarifadoModal from "@/modules/almoxarifados/devolucao/TarefaAprovacaoAlmoxarifadoModal.vue"
import TarefaAprovacaoSolicitanteModal from "@/modules/almoxarifados/devolucao/TarefaAprovacaoSolicitanteModal.vue"
import LgFinderPageAlmoxarifado from "../../../components/Finders/LgFinderPageAlmoxarifado.vue"
import verificaPrivilegio from "@/utils/VerificaPrivilegio"
import PrivilegiosEnum from "@/core/utils/PrivilegioEnum"


export default {
    mixins: [Formatters, ConfirmMixin, ListResourceMixin, FormResourceMixin],

    components: {
        LgFormSelect,
        LgFormInput,
        TarefaAprovacaoAlmoxarifadoModal,
        TarefaAprovacaoSolicitanteModal,
        LgFinderPageAlmoxarifado,
    },

    props: {
        numeroDevolucao: Number,
        prefix: {
            type: String,
            default: "",
        },

    },


    data() {
        return {
            title: "Tarefa",
            isVisualizacao: false,
            perPage: 10,
            perPageOptions: [10, 25, 50, 100],
            showTarefaAprovacaoAlmoxarifadoModal: false,
            showTarefaAprovacaoSolicitanteModal: false,
            form: {
                id: "",
                tarefaId: null,
                almoxarifado: {},
                status: { id: -1, descricao: "Aguardando/Em Andamento" },
                tipoTarefa: { id: null, descricao: "Todos" },
            },
            inLoading: false,
            records: [],
            selectedItem: {},
            statusOptions: [],
        }
    },

    async beforeMount() {
        this.$service = new ResourceService(`/api/tarefadevolucao`)
        this.$serviceDevolucao = new ResourceService(
            `/api/tarefadevolucao/devolucao`
        )
        this.$statusService = new ResourceService(
            `/api/status/tipo/37`
        )
        this.$serviceStatus = new ResourceService(`/api/status`)
        this.$serviceTipoTarefaDevolucao = new ResourceService(
            `/api/tipotarefadevolucao`
        )

        this.load();
    },


    watch: {
        page() {
            this.load()
        },


    },

    computed: {
        tableFields() {
            return [
                {
                    key: "id",
                    label: "Número",
                    thStyle: "width: 5%; font-size: 12px; ",
                    tdStyle: "width: 5%; font-size: 13px",
                },
                {
                    key: "devolucao.id",
                    label: "Devolução",
                    thStyle: "width: 5%; font-size: 10px; ",
                    tdStyle: "width: 5%; font-size: 13px",
                    tdClass: "text-center",
                    thClass: "text-center",
                },
                {
                    key: "status.descricao",
                    label: "Status",
                    thClass: "text-center",
                    tdClass: "text-center",
                    thStyle: "width: 10%; font-size: 12px",
                    tdStyle: "width: 10%; font-size: 13px",
                },
                {
                    key: "devolucao.departamento.descricao",
                    label: "Solicitante",
                    thStyle: "font-size: 12px; ",
                    tdStyle: "font-size: 13px",
                },
                {
                    key: "almoxarifado.descricao",
                    label: "Destino",
                    thStyle: " font-size: 12px; ",
                    tdStyle: " font-size: 13px",
                },
                {
                    key: "pessoa.nome",
                    label: "Responsável",
                    thStyle: "font-size: 12px; ",
                    tdStyle: "font-size: 13px",
                    thClass: "text-center",
                    tdClass: "text-center",
                },
                {
                    key: "tipoTarefaDevolucao",
                    label: "Tarefa",
                    thStyle: " font-size: 12px",
                    tdStyle: " font-size: 13px",
                    thClass: "text-center",
                    tdClass: "text-center",
                },
                {
                    key: "dhCriacao",
                    label: "Data",
                    formatter: this.$formatDatetime,
                    thStyle: "font-size: 12px; width: 10%;",
                    tdStyle: "font-size: 13px; width: 10%;",
                    thClass: "text-center",
                    tdClass: "text-center",
                },

                {
                    key: "actionButtons",
                    label: "",
                    thStyle: "width: 2%; font-size: 16px;",
                    tdClass: "text-center",
                },
            ]
        },
    },

    methods: {
        setAlmoxarifado(almoxarifado) {
            this.form.almoxarifado = almoxarifado;
            this.load();
        },
        verificaPrivilegioTarefa(tarefa) {

            if (tarefa.tipoTarefaDevolucao.id == 13)
                return verificaPrivilegio(PrivilegiosEnum.DEVOLUCAO_RECEBER)
            else
                return verificaPrivilegio(PrivilegiosEnum.DEVOLUCAO_APROVAR);
        },

        async load() {
            const filtro = {}
            if (
                this.form.almoxarifado &&
                this.form.almoxarifado.id
            ) {
                filtro.almoxarifadoId = this.form.almoxarifado.id
            }

            if (this.form.tarefaId != undefined && this.form.tarefaId != "") {
                filtro.tarefaId = this.form.tarefaId
            }


            if (this.form.tipoTarefa != undefined && this.form.tipoTarefa.id != "") {
                filtro.tipoTarefaDevolucaoId = this.form.tipoTarefa.id
            }

            if (this.form.status) {
                filtro.statusId = this.form.status.id
            }

            this.busy = true

            await this.$loadResource({
                size: this.perPage,
                page: this.page,
                params: filtro,
            });
            this.busy = false

        },

        clearForm() {
            this.form.almoxarifado = {}
            this.form.tarefaId = null
            this.form.status = { id: -1, descricao: "Aguardando/Em Andamento" }
            this.form.tipoTarefa = { id: null, descricao: "Todos" }
            this.load()
        },

        listStatus({ filter, page = 1 }) {
            return this.$statusService
                .findAll({
                    filter,
                    page,
                    limit: 5,
                })
                .then(response => {
                    response.data.content.unshift({
                        id: -1,
                        descricao: "Aguardando/Em Andamento",
                    })
                    return response;
                });
        },

        async listTipoTarefaDevolucao({ filter, page = 1 }) {

            return this.$serviceTipoTarefaDevolucao.findAll({
                filter,
                page,
                limit: 5,
            })
        },

        async alteraStatus(item, statusId) {
            const { status } = this.$service.alteraStatus(item, statusId)
            if (status == 200) {
                this.$notify({
                    type: "success",
                    message: `Registro de entrada ${status.descricao}!`,
                })
            } else {
                this.$notify({
                    type: "danger",
                    message: `Erro ao alterar status para ${status.descricao}!`,
                })
                item.status = status
            }
        },

        tarefaAprovacaoSolicitanteFinalizado() {
            this.isVisualizacao = false
            this.showTarefaAprovacaoSolicitanteModal = false
            this.load()
        },

        tarefaAprovacaoAlmoxarifadoFinalizado() {
            this.isVisualizacao = false
            this.showTarefaAprovacaoAlmoxarifadoModal = false
            this.load()
        },

        async iniciarTarefa(item) {
            let response = await this.$confirm(
                `Deseja iniciar esta tarefa (${item.tipoTarefaDevolucao.descricao}) ?`
            )
            if (response) {
                item.status.id = 128
                item.status.descricao = "Em andamento"
                this.$service.save(item)
                if (
                    item.tipoTarefaDevolucao.id === 10
                ) {
                    this.abrirModalAlmoxarifadoModal(item)
                }
                if (item.tipoTarefaDevolucao.id === 13) {
                    this.abrirModalSolicitanteModal(item)
                }
            } else {
                return
            }
        },

        abrirDetalhe(item) {
            this.isVisualizacao = true

            if (item.tipoTarefaDevolucao.id === 10) {
                this.abrirModalAlmoxarifadoModal(item)
            } else {
                this.abrirModalSolicitanteModal(item)
            }
        },

        async abrirModalAlmoxarifadoModal(item) {
            this.selectedItem = item
            this.showTarefaAprovacaoAlmoxarifadoModal = true
        },

        async abrirModalSolicitanteModal(item) {
            this.selectedItem = item
            this.showTarefaAprovacaoSolicitanteModal = true
        },

        modalClose() {
            this.showTarefaAprovacaoAlmoxarifadoModal = false
            this.showTarefaAprovacaoSolicitanteModal = false
            this.isVisualizacao = false
        },

        emDigitacao(status) {
            return status.id === 26
        },
    },
}
</script>
<style>
.vs__selected {
    white-space: nowrap;
}
</style>
